import { toast } from 'react-toastify';
import { GENERIC_ERROR_MESSAGE } from '@constants';

const showError = (error) => {
  let message = GENERIC_ERROR_MESSAGE;

  if (typeof error === 'string') {
    message = error;
  } else if (error instanceof Error) {
    // Handles TypeError, ReferenceError, etc.
    message = error.message || message;
  } else if (Array.isArray(error)) {
    error.forEach((msg) => toast.error(msg));
    return;
  }
  toast.error(message);
};

export default showError;
